/* Chollo Club — theme.js
   JavaScript ligero, sin dependencias. Mejora progresiva: todas las acciones
   críticas (añadir al carrito, actualizar carrito, filtros, búsqueda) funcionan
   también sin JavaScript mediante formularios nativos de Shopify. */
(function () {
  'use strict';

  var T = window.theme || {};
  T.routes = T.routes || {};
  T.strings = T.strings || {};

  /* ---------- Utilidades ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function fetchJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { throw j; } return j; }); });
  }

  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) { el = document.createElement('div'); el.id = 'Toast'; el.className = 'toast'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Drawers (menú móvil, filtros, carrito) ---------- */
  var lastFocus = null;
  var focusableSel = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $(focusableSel, $('.drawer__panel', d));
    if (f) setTimeout(function () { f.focus(); }, 60);
    return true;
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    $$('[data-drawer-open="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  T.openDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.getAttribute('data-drawer-open') === 'CartDrawer' && T.cartType !== 'drawer') return;
      if (openDrawer(opener.getAttribute('data-drawer-open'))) e.preventDefault();
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });

  document.addEventListener('keydown', function (e) {
    var open = $('.drawer.is-open');
    if (!open) return;
    if (e.key === 'Escape') { closeDrawer(open); return; }
    if (e.key === 'Tab') {
      var items = $$(focusableSel, $('.drawer__panel', open)).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Barra de anuncios ---------- */
  function initAnnouncement(root) {
    var slides = $$('.announcement-bar__slide', root);
    if (slides.length < 2) return;
    var i = 0, speed = parseInt(root.getAttribute('data-speed'), 10) || 5, timer;
    function go(n) {
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); slides[i].setAttribute('aria-hidden', 'false');
    }
    function play() { if (root.getAttribute('data-autoplay') === 'true') { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed * 1000); } }
    $$('[data-announcement-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(i - 1); play(); }); });
    $$('[data-announcement-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(i + 1); play(); }); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', function () { clearInterval(timer); });
    play();
  }

  /* ---------- Encabezado ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (header && header.classList.contains('is-sticky')) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    $$('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('aria-controls'));
        if (!target) return;
        var hidden = target.hasAttribute('hidden');
        if (hidden) { target.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); var inp = $('input[type="search"]', target); if (inp) inp.focus(); }
        else { target.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
      });
    });
    // Cerrar desplegables de escritorio al hacer clic fuera o pulsar Escape
    document.addEventListener('click', function (e) {
      $$('.header-nav details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.header-nav details[open]').forEach(function (d) { d.removeAttribute('open'); var s = $('summary', d); if (s) s.focus(); });
    });
  }

  /* ---------- Búsqueda predictiva ---------- */
  function initPredictive(form) {
    var input = $('input[type="search"]', form);
    var results = $('[data-predictive-results]', form);
    if (!input || !results || !T.routes.predictive_search) return;
    var controller;
    function close() { results.setAttribute('hidden', ''); input.setAttribute('aria-expanded', 'false'); }
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = T.routes.predictive_search + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var content = $('#shopify-section-predictive-search', doc);
          results.innerHTML = content ? content.innerHTML : '';
          results.removeAttribute('hidden');
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function () { /* silencioso: el formulario sigue funcionando */ });
    }, 280);
    input.addEventListener('input', run);
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); } });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  /* ---------- Cantidad (+/-) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.quantity');
    var input = wrap && $('input', wrap);
    if (!input) return;
    e.preventDefault();
    var step = parseInt(input.step, 10) || 1;
    var min = input.min !== '' ? parseInt(input.min, 10) : 0;
    var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
    var val = (parseInt(input.value, 10) || 0) + (btn.getAttribute('data-qty-change') === 'plus' ? step : -step);
    input.value = Math.max(min, Math.min(max, val));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Carrito ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    $$('[data-cart-count-label]').forEach(function (el) {
      el.textContent = (T.strings.cartCount || '[count]').replace('[count]', count);
    });
  }

  function cartSectionIds() {
    var ids = [];
    $$('[data-cart-section]').forEach(function (el) { var id = el.getAttribute('data-cart-section'); if (id && ids.indexOf(id) < 0) ids.push(id); });
    return ids;
  }

  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = parseHTML(html);
      $$('[data-cart-section="' + id + '"]').forEach(function (target) {
        var fresh = $('[data-cart-section="' + id + '"]', doc);
        if (fresh) target.innerHTML = fresh.innerHTML;
      });
    });
  }

  function changeLine(line, quantity, root) {
    var ids = cartSectionIds();
    if (root) root.classList.add('is-updating');
    return fetchJSON(T.routes.cart_change + '.js', { line: line, quantity: quantity, sections: ids, sections_url: window.location.pathname })
      .then(function (cart) {
        renderCartSections(cart.sections);
        updateCartCount(cart.item_count);
        var live = $('#CartLiveRegion');
        if (live) live.textContent = T.strings.cartUpdated || '';
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || T.strings.cartError;
        $$('[data-cart-errors]').forEach(function (el) { el.textContent = msg; });
        toast(msg);
      })
      .finally(function () { $$('.is-updating').forEach(function (el) { el.classList.remove('is-updating'); }); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-line'), 10);
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;
    debouncedChange(line, qty, input.closest('.cart-item'));
  });
  var pending = {};
  function debouncedChange(line, qty, row) {
    clearTimeout(pending[line]);
    pending[line] = setTimeout(function () { changeLine(line, qty, row); }, 350);
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(parseInt(rm.getAttribute('data-line'), 10), 0, rm.closest('.cart-item'));
  });

  /* ---------- Añadir al carrito ---------- */
  function addToCart(form) {
    var btn = $('[type="submit"][name="add"]', form);
    var errorBox = $('[data-product-error]', form.closest('[data-product-root]') || form);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    if (errorBox) { errorBox.textContent = ''; errorBox.setAttribute('hidden', ''); }
    var fd = new FormData(form);
    var ids = cartSectionIds();
    if (ids.length) { fd.append('sections', ids.join(',')); fd.append('sections_url', window.location.pathname); }
    return fetch(T.routes.cart_add + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (item) {
        renderCartSections(item.sections);
        return fetch(T.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (T.cartType === 'drawer' && document.getElementById('CartDrawer')) openDrawer('CartDrawer');
        else if (T.cartType === 'page') window.location.href = T.routes.cart;
        else toast(T.strings.addedToCart);
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || T.strings.cartError;
        if (errorBox) { errorBox.textContent = msg; errorBox.removeAttribute('hidden'); }
        else toast(msg);
      })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]') || form.hasAttribute('data-no-ajax')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    addToCart(form);
  });

  /* ---------- Producto: variantes ---------- */
  function formatMoney(cents) {
    var fmt = T.moneyFormat || '{{amount}}';
    var value = (cents / 100);
    function withDelims(n, decimals, thou, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return withDelims(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        case 'amount_with_space_separator': return withDelims(value, 2, ' ', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  function initProduct(root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var form = $('form[action*="/cart/add"]', root);
    var idInput = form && $('input[name="id"]', form);
    var pickers = $$('[data-option-index]', root);
    var addBtn = form && $('[name="add"]', form);
    var addLabel = addBtn && $('[data-add-label]', addBtn);
    var priceBox = $('[data-price]', root);
    var stockBox = $('[data-stock]', root);
    var skuBox = $('[data-sku]', root);
    var lowStock = parseInt(root.getAttribute('data-low-stock'), 10) || 0;
    var updateUrl = root.getAttribute('data-update-url') === 'true';

    function selectedOptions() {
      var opts = [];
      pickers.forEach(function (p) {
        var idx = parseInt(p.getAttribute('data-option-index'), 10);
        if (p.tagName === 'SELECT') opts[idx] = p.value;
        else { var c = $('input:checked', p); opts[idx] = c ? c.value : null; }
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
    }

    function markAvailability(opts) {
      // Marca combinaciones no disponibles respecto a la primera opción elegida
      pickers.forEach(function (p) {
        var idx = parseInt(p.getAttribute('data-option-index'), 10);
        $$('input[type="radio"]', p).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return test[i] === o; }); });
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function render(variant) {
      var stickyBtn = $('[data-sticky-atc] [data-sticky-add]');
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = T.strings.unavailable; }
        if (stickyBtn) stickyBtn.disabled = true;
        if (stockBox) { stockBox.className = 'stock stock--out'; stockBox.textContent = T.strings.unavailable; }
        return;
      }
      if (idInput) { idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      }
      if (stickyBtn) stickyBtn.disabled = !variant.available;
      if (priceBox) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var html = '<span class="visually-hidden">' + (T.strings.price || '') + '</span><span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (onSale) html += '<span class="visually-hidden">' + (T.strings.regularPrice || '') + '</span><s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        priceBox.innerHTML = html;
        priceBox.classList.toggle('price--sale', !!onSale);
        var saveBadge = $('[data-save-badge]', root);
        if (saveBadge) {
          if (onSale) { var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price); saveBadge.textContent = (T.strings.savePercent || '-[percent]%').replace('[percent]', pct); saveBadge.removeAttribute('hidden'); }
          else saveBadge.setAttribute('hidden', '');
        }
      }
      if (stockBox) {
        var inv = root.querySelector('[data-inventory="' + variant.id + '"]');
        var qty = inv ? parseInt(inv.getAttribute('data-qty'), 10) : NaN;
        var tracked = inv && inv.getAttribute('data-tracked') === 'true';
        if (!variant.available) { stockBox.className = 'stock stock--out'; stockBox.textContent = T.strings.soldOut; }
        else if (tracked && !isNaN(qty) && qty > 0 && lowStock > 0 && qty <= lowStock) { stockBox.className = 'stock stock--low'; stockBox.textContent = (T.strings.lowStock || '').replace('[count]', qty); }
        else { stockBox.className = 'stock'; stockBox.textContent = T.strings.inStock; }
      }
      if (skuBox) { skuBox.textContent = variant.sku || ''; skuBox.parentElement.hidden = !variant.sku; }
      if (variant.featured_media) {
        var gallery = $('[data-gallery]', root);
        if (gallery && gallery.goToMedia) gallery.goToMedia(variant.featured_media.id);
      }
      $$('[data-option-value-label]', root).forEach(function (lab) {
        var idx = parseInt(lab.getAttribute('data-option-value-label'), 10);
        lab.textContent = variant.options[idx] || '';
      });
      if (updateUrl && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    pickers.forEach(function (p) {
      p.addEventListener('change', function () {
        var opts = selectedOptions();
        markAvailability(opts);
        render(findVariant(opts));
      });
    });
    markAvailability(selectedOptions());
  }

  /* ---------- Galería ---------- */
  function initGallery(root) {
    var track = $('.gallery__slides', root);
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('.gallery__thumb', root);
    var counter = $('[data-gallery-counter]', root);
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    function go(i, smooth) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('scroll', debounce(function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i !== current && slides[i]) setActive(i);
    }, 80), { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    root.goToMedia = function (mediaId) {
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) go(idx);
    };
    setActive(0);
  }

  /* ---------- Barra fija de compra (móvil) ---------- */
  function initStickyATC() {
    var bar = $('[data-sticky-atc]');
    var mainBtn = $('[data-product-root] [name="add"]');
    if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var visible = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }).observe(mainBtn);
    var stickyAdd = $('[data-sticky-add]', bar);
    if (stickyAdd) stickyAdd.addEventListener('click', function () {
      var form = mainBtn.closest('form');
      if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
    });
  }

  /* ---------- Recomendaciones de producto ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = parseHTML(html);
      var fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim().length) {
        el.innerHTML = fresh.innerHTML;
        if (!$('.card', el)) el.closest('.shopify-section').setAttribute('hidden', '');
      } else {
        el.closest('.shopify-section').setAttribute('hidden', '');
      }
    }).catch(function () {});
  }

  /* ---------- Filtros y ordenamiento ---------- */
  function initFacets(form) {
    var submit = debounce(function () {
      var params = new URLSearchParams(new FormData(form));
      // Elimina parámetros vacíos (rango de precio sin valor)
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      window.location.search = params.toString();
    }, 500);
    form.addEventListener('change', function (e) { if (e.target.matches('input[type="checkbox"], select')) submit(); });
    $$('input[type="number"]', form).forEach(function (i) { i.addEventListener('input', submit); });
  }

  /* ---------- Compartir ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    var data = { title: document.title, url: btn.getAttribute('data-url') || window.location.href };
    if (navigator.share) { navigator.share(data).catch(function () {}); }
    else if (navigator.clipboard) { navigator.clipboard.writeText(data.url).then(function () { toast(T.strings.linkCopied); }); }
  });

  /* ---------- Envío automático (localización, ordenamiento) ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-localization-select], [data-auto-submit]');
    if (sel && sel.form) sel.form.submit();
  });

  /* ---------- Inicio ---------- */
  function init() {
    $$('[data-announcement]').forEach(initAnnouncement);
    initHeader();
    $$('[data-predictive-search]').forEach(initPredictive);
    $$('[data-product-root]').forEach(initProduct);
    $$('[data-gallery]').forEach(initGallery);
    $$('[data-recommendations-url]').forEach(function (el) { el.setAttribute('data-url', el.getAttribute('data-recommendations-url')); initRecommendations(el); });
    $$('[data-facets-form]').forEach(initFacets);
    initStickyATC();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Re-inicializa secciones al editarlas en el personalizador de Shopify
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    $$('[data-announcement]', s).forEach(initAnnouncement);
    $$('[data-predictive-search]', s).forEach(initPredictive);
    $$('[data-product-root]', s).forEach(initProduct);
    $$('[data-gallery]', s).forEach(initGallery);
    $$('[data-recommendations-url]', s).forEach(function (el) { el.setAttribute('data-url', el.getAttribute('data-recommendations-url')); initRecommendations(el); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target;
    if (slide.classList && slide.classList.contains('announcement-bar__slide')) {
      $$('.announcement-bar__slide', slide.parentElement).forEach(function (s) { s.classList.toggle('is-active', s === slide); });
    }
  });
})();
